import React from 'react';
import './Tablecard.css';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/Authcontext';

function Tablecard(props) {

    const {userdata, login, isloggedin} = useAuth();
    // const [dis, setDis] = useState('block');

    const addtoCartFunc = (num) => {
        if(isloggedin){
            fetch(`https://pentadeco.in/api/addtocart`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({productId: props.id, quantity: num, userId: userdata?._id})
            }).then(res => res.json()).then(data => {
                console.log(data);
                if(data.success){
                    window.location.reload();
                }
            }).catch(err => console.log("error occured while adding to the cart", err));
        }
    }

  return (
    <div className='main-table-card rounded-brand-lg overflow-hidden border'>
        <div className='p-0 m-0'>
            <div className="table-card-wrap row align-items-center p-0 m-0">
                <div className="col-md-2 col-4 p-0">
                    <Link to={`/${props?.id}/${props?.name?.replace(/ /g, '_')}`} className='nav-link p-2'>
                        <img src={props?.img} alt={props?.name} className="img-fluid rounded-brand" />
                    </Link>
                </div>
                <div className="col-md-10 col-8 py-2">
                    <Link to={`/${props?.id}/${props?.name?.replace(/ /g, '-')}`} className="nav-link mb-0 body-font-bold text-capitalize fs-sm lh-sm">{props.name.length > 50? props.name.slice(0, 20) + '...': props.name }</Link>
                    <div className="d-flex justify-content-between align-items-end mt-2">
                        <p className="mb-0 body-font-bold">₹{props?.disprice}</p>
                        <div className="col-md-3 col-6 justify-content-between align-items-center border rounded-brand-sm overflow-hidden" style={{display: window.location.pathname === '/cart'? 'flex': 'none'}}>
                            <button className='btn bg-white fs-sm py-1' onClick={()=> addtoCartFunc(-1)}>-</button>
                            <p className="mb-0 px-1 fs-sm py-1">{props.quantity}</p>
                            <button className='btn bg-white fs-sm py-1' onClick={()=> addtoCartFunc(1)}>+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Tablecard;

// onClick={()=> setQuantity(props.quantity > 1? props.quantity - 1: 1)}
// onClick={()=> setQuantity(props.quantity < 10? props.quantity + 1: 10)}